import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ApproveRejectReportDto, OperationResultDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class ReportApprovalService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  process = (input: ApproveRejectReportDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OperationResultDto>({
      method: 'POST',
      url: '/api/app/report-approval/process',
      body: input,
    },
    { apiName: this.apiName,...config });
}